import React, { Component } from 'react';
import styled from 'styled-components';
import Bar from './Bar.jsx';
import data from './data.json';
import colors from './mot-colors.json';
import delimiter from './delimiter.js';
import Foldable from './Foldable.js';

const translation = {
  'Adolescents': 'Nuoret',
  'Arrested drug users': 'Pidätetyt huumeidenkäyttäjät',
  'Athletes': 'Urheilijat',
  'Bodybuilders': 'Kehonrakentajat',
  'Drug users': 'Huumeidenkäyttäjät',
  'Former athletes': 'Entiset urheilijat',
  'General': 'Yleinen',
  'Gym users': 'Kuntosalilla kävijät',
  'High school': 'Toisen asteen opiskelijat',
  'Military conscripts': 'Varusmiehet',
  'Prisoners': 'Vangit',
  'Recreational sportspeople': 'Harrasteurheilijat',
  'Weightlifters': 'Painonnostajat',
  'Denmark': 'Tanska', 
  'Finland': 'Suomi', 
  'Iceland': 'Islanti', 
  'Norway': 'Norja',
  'Sweden': 'Ruotsi',
  'NR': 'Ei satunnaisotantaa',
  'R': 'Satunnaisotanta'
};

const subGraphData = [
  {name: 'Painonnostajat ja kehonrakentajat', includes: ['Weightlifters', 'Bodybuilders']},
  {name: 'Huumeidenkäyttäjät', includes: ['Drug users', 'Arrested drug users']},
  {name: 'Vangit', includes: ['Prisoners']},
  {name: 'Urheilijat', includes: ['Athletes', 'Former athletes']},
  {name: 'Nuoret ja toisen asteen opiskelijat', includes: ['Adolescents', 'High school']},
  {name: 'Kuntosalilla kävijät ja harrasteurheilijat', includes: ['Recreational sportspeople', 'Gym users']},
  {name: 'Yleinen ja varusmiehet', includes: ['General', 'Military conscripts']}
];

const noteTop = 'Prosenttia osallistuneista';
const noteBottom = 'Lähde: Anabolic-Androgenic Steroid use in the Nordic Countries: A Meta-Analysis and Meta-Regression Analysis, 2014';

const renderInfo = (d) => {
  return (
    <div className="info">
      <h4>{ d.id }</h4>
      <p className="info-item"><span className="info-item-category">Maa:</span> { translation[d.country] }</p> 
      <p className="info-item"><span className="info-item-category">Kohderyhmä:</span> { translation[d.sample_type] }</p>
      <p className="info-item"><span className="info-item-category">Otoksen koko:</span> { delimiter(d.n) }</p>
      <p className="info-item">{ translation[d.sampling_method] }</p>
    </div>
  );
};

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected: {
        'Painonnostajat ja kehonrakentajat': 0
      }
    };
  }

  render() {
    return (
      <div className={ this.props.className }>
        {
          subGraphData.map((category,categoryIndex) => {
            return (
              <div key={ category.name } className="category">
                <h3>{ category.name }</h3>
                { categoryIndex === 0 ? <p className="note-top">{ noteTop }</p> : null }
                <Foldable 
                  maxHeight={ 170 }
                  selected={ this.state.selected[category.name] } 
                  onClick={ (i) => this.setState(state => Object.assign(state, { selected: Object.assign(state.selected, {[category.name]: state.selected[category.name] === i ? null : i })})) }
                >
                { 
                  data.filter(d => category.includes.indexOf(d.sample_type) !== -1).map((d,i) => {
                    return (
                      <div key={i}>
                        <Bar background={ this.state.selected[category.name] === i ? colors.red : colors.cyan } 
                             value={ d.prevalence_overall } 
                             valueKey={ d.prevalence_overall.toString().replace('.', ',') } 
                             maxValue="100" />
                        { renderInfo(d) }
                      </div> 
                    );
                  })
                } 
                </Foldable>

              </div>
            );
          })
        }
        <p className="note-bottom">{ noteBottom }</p>
      </div>
    );
  }
}

const StyledApp = styled(App)`
  
  font-family: sans-serif;
  line-height: initial;

  .category {
    margin-bottom: 20px;
  }
  
  h3 {
    font-size: 18px;
    margin: 15px 0 5px 0;
  }

  .info {
    margin-bottom: 15px;
    padding-left: 10px;
    border-left: 1px dotted #666;
  }

  .info h4 {
    font-size: 14px;
    margin: 10px 0;
  }

  .info p {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin: 1px 0;
  }

  .info-item-category {
    font-weight: bold;
  }

  .note-top, .note-bottom {
    color: ${ colors.grayDark };
    font-size: 12px;
  }

  .note-top {
    margin: 0 0 1px 0;
  }

`;

export default StyledApp;



// WEBPACK FOOTER //
// ./src/App.js